import React, { useEffect, useState } from 'react';
import { fetcher } from '../../../../../../helpers/fetcher';
import { configApiLinks } from '../../../../../../configApiLinks';
import {
  setCheckData,
} from '../../../../../../actions/checks';
import { useDispatch } from 'react-redux';

export const useReceiptPostpone = () => {
  const [modalShow, setModalShow] = useState(false);
  const [showLoader, setShowLoader] = useState(false);
  const dispatch = useDispatch();

  const postponeReceipt = () => {
    setShowLoader(true);
    fetcher(configApiLinks.postponeReceipt, 'POST', {})
      .then((data) => {
        setShowLoader(false);
        dispatch(setCheckData(data));
        setModalShow(false);
      }).catch((data) => {
        setShowLoader(false);
        console.error('Error fetching postponed receipts:', data);
      });
  };

  // here we put
  const delay = (callback, ms) => {
    let timer = 0;
    // return function because keyup require function
    return function () {
      let context = this;
      let args = arguments;
      // if we put something again clear timer (do not wait for result function below) amd start timer again
      clearTimeout(timer);
      timer = setTimeout(function () {
        // runs function on key up ajax send format url etc...
        callback.apply(context, args);
      }, ms);
    };
  };
  return {
    delay,
    postponeReceipt,
    modalShow,
    showLoader,
    setModalShow,
  };
};
